export const CONSTANTS_SCHEDULE = {
    CLASS_APPOINTMENT_BEHAVIOUR: [
      { name: 'Anyone (Free)', value: 'Anyone_Free', icon: 'fa fa-wallet' },
      { name: 'Session Pack', value: 'Session_Pack', icon: 'fa fa-dollar' },
      { name: 'Membership + Session Pack', value: 'Membership_Session_Pack', icon: 'fa fa-dollar' },
      { name: 'Members only Session', value: 'Members_Only_Session', icon: 'fa fa-dollar' },
    ] as Behaviour[],
}

  interface Behaviour {
    name: string;
    value: string;
    icon: string;
  }
  